var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-container",style:([_vm.container_Style])},[(_vm.mytype == '2')?_c('div',{staticClass:"titlebox"},[_vm._m(0),_c('div',{staticClass:"phone_body"},[_vm._v(" "+_vm._s(_vm.mytitle)+" ")])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgimg"},[_c('div',{staticClass:"white_block"})])
}]

export { render, staticRenderFns }